module.exports = __webpack_public_path__ + "cc394df4451a9356139eeeeb7b7cc1f9.svg";